export type SuggestiveSellingGridDensity = 'medium' | 'compact';

export interface SuggestiveSellingGridLayout {
    density: SuggestiveSellingGridDensity;
    /** Columns per row below lg (and for row chunking on smaller viewports). */
    columnsPerRow: number;
    /** Columns per row at lg and up; defaults to columnsPerRow when omitted. */
    columnsPerRowLg: number;
    gridItemProps: {xs: number; sm: number; md: number; lg: number; xl?: number};
    cardMinHeight: number;
    descriptionLineClamp: number;
    rowHeight: number;
    spacing: number;
}

/** MUI Grid2 `size` for N equal columns in a 12-column grid. */
function gridSizeForColumns(columns: number): number {
    return 12 / columns;
}

/**
 * Below lg: 3 / 4 / 6 columns by item count. At lg+: smallest lists use 4 columns instead of 3.
 */
export function getSuggestiveSellingGridLayout(itemCount: number): SuggestiveSellingGridLayout {
    if (itemCount <= 12) {
        const columnsMd = 3;
        const columnsLg = 4;
        return {
            density: 'medium',
            columnsPerRow: columnsMd,
            columnsPerRowLg: columnsLg,
            gridItemProps: {
                xs: 12,
                sm: 6,
                md: gridSizeForColumns(columnsMd),
                lg: gridSizeForColumns(columnsLg),
                xl: gridSizeForColumns(columnsLg),
            },
            cardMinHeight: 152,
            descriptionLineClamp: 3,
            rowHeight: 176,
            spacing: 1.25,
        };
    }
    if (itemCount <= 24) {
        const columns = 4;
        const size = gridSizeForColumns(columns);
        return {
            density: 'medium',
            columnsPerRow: columns,
            columnsPerRowLg: columns,
            gridItemProps: {xs: 12, sm: 6, md: size, lg: size, xl: size},
            cardMinHeight: 140,
            descriptionLineClamp: 3,
            rowHeight: 160,
            spacing: 1,
        };
    }
    const columns = 6;
    const size = gridSizeForColumns(columns);
    return {
        density: 'compact',
        columnsPerRow: columns,
        columnsPerRowLg: columns,
        gridItemProps: {xs: 6, sm: 4, md: size, lg: size, xl: size},
        cardMinHeight: 132,
        descriptionLineClamp: 3,
        rowHeight: 148,
        spacing: 1,
    };
}
